<style>
.v-avatar img {
  height: 25px !important;
  width: 25px !important;
}
.v-list__tile {
  height: 100% !important;
}
.list__tile:hover {
  background-color: lightgray;
}
.pagination__buttons {
  justify-content: center;
}
.pagination__button {
  font-size: 30px !important;
}
.events__span {
  display: flex;
  align-items: center;
}
.events__container .layout:not(.pagination__buttons) {
  display: block;
}
</style>

<template>
  <v-layout>
    <v-flex
      xs12
      class="events__container"
    >
      <span
        class="events__span"
        v-if="module == 'addEventsToObjects' || $can('read', module + '_comments') || $can('edit', module) || module === 'canEditUserLayer' || module === 'canAddEvent'"
      >
        <span class="group">
          <v-icon
            style="font-size:20px; margin-top:3px;"
            class="table__btn--green"
            @click="addEvent()"
            title="Dodaj komentarz"
          >add_circle</v-icon>

        </span>
        <v-subheader class="font--primary">DODAJ ZDARZENIE</v-subheader>
      </span>
      <div v-if="allFeatureEvents.length > 0">
        <!-- <ul
            class="values__list"
            style="list-style-type:none; padding-left: 0px;"
          >
            <v-flex xs12>
              <li
                class="list__container--el"
                v-for="(event, index) in filteredEvents"
                :key="index"
              >
                <span v-text="event.user"></span>
                <span v-text="event.description"></span>
              </li>
            </v-flex>
        </ul>-->
        <v-list>
          <v-list-tile
            class="list__tile"
            v-for="(event, index) in filteredEvents"
            v-if="index<5"
            :key="index"
            avatar
            style="border: 1px solid lightgrey; height:60px"
          >
            <!-- <v-list-tile-avatar>
              <v-tooltip
                top
                dark
                color="lightgrey"
              >
                <img
                  class="avatar__img"
                  slot="activator"
                  :src="require('@/avatar.png')"
                >
                <span>{{event.username}}</span>
              </v-tooltip>
            </v-list-tile-avatar> -->
            <v-list-tile-content>
              <v-layout style="width: 100%;">
                <v-layout
                  row
                  wrap
                  style="height: 50%;line-height: 29px;"
                >
                  <v-flex
                    xs12
                    style="color:#304058;font-weight:550"
                  >
                    {{event.formatedDate}} <span style="margin-left: 15px">{{event.username}}</span>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  style="height: 50%;line-height: 29px;"
                >
                  <v-flex xs12>{{event.description}}</v-flex>
                </v-layout>
              </v-layout>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-layout class="pagination__buttons">
          <v-icon
            depressed
            :disabled="isDisabledPrevious"
            class="pagination__button pagination__button--previous"
            @click="previousEvents()"
          >
            keyboard_arrow_left
          </v-icon>
          <v-icon
            :disabled="isDisabledNext"
            depressed
            class="pagination__button pagination__button--next"
            @click="nextEvents()"
          >
            keyboard_arrow_right
          </v-icon>
        </v-layout>
      </div>

      <div v-else>
        <v-card-text
          class="msg--no-data"
          style="font-weight: bolder"
        >
          Brak dostępnych zdarzeń
        </v-card-text>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";

import get from "lodash/get";

export default {
  props: {
    featureEvents: Object,
    objectType: String,
    objectTable: String,
    id: Number,
    module: {
      type: String,
      required: false
    },
  },
  data: () => ({
    filteredEvents: [],
    page: 1,
    allFeatureEvents: [],
    isDisabledPrevious: true,
    isDisabledNext: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    eventsOnPage() {
      if(this.allFeatureEvents) {
        let filteredEvents = [];
        moment.locale("pl");
        for(let i = (this.page - 1) * 5; i <= (this.page - 1) * 5 + 4; i++) {
          if(this.allFeatureEvents[i] != undefined) {
            this.allFeatureEvents[i].formatedDate = moment(
              this.allFeatureEvents[i].created_at
            ).format("DD.MM.YYYY, H:mm");
            this.allFeatureEvents[i].timeAgo = moment(
              this.allFeatureEvents[i].created_at
            ).fromNow();
            filteredEvents.push(this.allFeatureEvents[i]);
          }
        }
        this.filteredEvents = filteredEvents;
      }
    },
    addEvent() {
      let data = {
        object_id: this.id,
        object_table: this.objectTable,
        object_type: this.objectType
      };
      this.$store.commit("setCurrentEditedObject", data);
      this.show("addEventModal");
    },
    setAllFeatureEvents() {
      this.allFeatureEvents = this.allFeatureEvents.concat(get(this.featureEvents, 'events', []));
    },
    previousEvents() {
      if(this.page == 2) {
        this.page -= 1
        this.isDisabledNext = false;
        this.isDisabledPrevious = true;
        this.eventsOnPage();
      }
      else if(this.page > 1) {
        this.page -= 1
        this.isDisabledNext = false;
        this.eventsOnPage();
      } else {
        this.isDisabledNext = false;
        this.isDisabledPrevious = true;
      }
    },
    nextEvents() {
      let payload = {
        object_id: this.id,
        object_table: this.objectTable,
        object_type: this.objectType,
        limit: 5,
        last: this.allFeatureEvents[this.allFeatureEvents.length - 1].id,
        events_count: true
      }
      if(this.allFeatureEvents[this.allFeatureEvents.length - 1] == this.filteredEvents[this.filteredEvents.length - 1]) {
        this.$store.dispatch("getFeatureEvents", payload).then(r => {
          this.featureEvents = r;
          if(this.featureEvents.events.length != 0) {
            this.setAllFeatureEvents()
            this.page += 1
            this.eventsOnPage()
            this.isDisabledPrevious = false;
          } else {
            this.$root.$emit("showSnackbar", "blue", "Przejrzałeś już wszystkie zdarzenia obiektu")
            this.isDisabledNext = true;
          }
        })
      } else {
        this.page += 1
        this.eventsOnPage()
        this.isDisabledPrevious = false;
      }
    },
    newEvent(data) {
      if(data == this.objectType) {
        this.allFeatureEvents.unshift(this.$store.getters.getFeatureEvents.events[0])
        this.filteredEvents.unshift(this.$store.getters.getFeatureEvents.events[0])
        if(this.allFeatureEvents.length == 6) {
          this.allFeatureEvents.splice(-1, 1)
        }
        this.page = 1;
        this.eventsOnPage()
      }
    }
  },
  mounted() {
    this.$root.$on("refreshEvents", this.newEvent);
    this.$root.$on("setAllFeatures", this.setAllFeatureEvents);
    this.$root.$on('loadEventsOnPage', this.eventsOnPage);
    this.eventsOnPage();
  },
  beforeMount() {
    this.setAllFeatureEvents();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Events.vue